import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzSelectComponent, NzSelectModule } from 'ng-zorro-antd/select';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { ApiService } from '../../Services/api.service';

@Component({
  selector: 'app-add-edit-customer-associate',
  standalone: true,
  imports: [CommonModule, NzCollapseModule, NzIconModule, NzButtonModule, NzSelectModule, FormsModule, ReactiveFormsModule, NzSwitchModule],
  templateUrl: './add-edit-customer-associate.component.html',
  styleUrl: './add-edit-customer-associate.component.scss'
})
export class AddEditCustomerAssociateComponent {
  constructor(private apiService: ApiService, private fb: FormBuilder) {

  }
  selectedUsers: any = [];
  locationList: any = [];
  jobCodeList: any = [];
  invalidForm: boolean = false;
  addEditUserForm: FormGroup = new FormGroup({});
  userArrayForm: FormGroup = new FormGroup({});
  associateUserFields: any = [
    {
      id: 1, fieldType: "accordion", collapse: true, groupHeader: "Group", required: true, placeholder: "Enter a Name", pageTypes: ["FA", "N", "S", "C1"],
      fields: [
        { fieldName: "AR No", disabled: true, fieldType: "input", placeholder: "", value: '', formControlName: "arNo" },
        { fieldName: "Customer Name", fieldType: "input", placeholder: "Enter Customer Name", value: "", formControlName: "custName", required: true, },
        { fieldName: "Login Page ID", fieldType: "dropdown", placeholder: "Enter Login Page ID", value: "", formControlName: "loginPageID", required: false },
        { fieldName: "Style Sheet", fieldType: "dropdown", placeholder: "Enter Style Sheet", value: "", formControlName: "styleSheet", required: false, },
        { fieldName: "Brand", fieldType: "dropdown", value: "", formControlName: "brand", required: false, }
      ]
    }
  ];
  repeatedLocation: boolean = false;
  @Output() emitData = new EventEmitter();
  @Output() closeDrawer = new EventEmitter();
  @Input() editData: any = [];
  selectedPairs: any = [];
  userList: any = [];
  invalidUserList: boolean = false;
  invalidUserForm: boolean = false;
  customerDropDownLists: any = [];



  userValChange(evt: any) {
    if (evt.length == 5) {
      this.apiService.getAssociateCustomerById(evt).subscribe(res => {
        if (res && res.length > 0) {
          this.userList = res;
          this.userList.map((node: any) => {
            Object.assign(node, { disabled: false })
          });
          if (this.selectedUsers && this.selectedUsers.length > 0) {
            const userSet = new Set(this.selectedUsers.map((node: any) => node.arNo));
            this.userList.forEach((node: any) => {
              if (userSet.has(node.arNo)) {
                node.disabled = true;
              }
            })
          }


        }
        else {
          // this.userList.push(res[0]);
        }
      })
    }
  }

 userChange(selectedArNos: string[]) {
  const form = this.addEditUserForm.get('userArray') as FormArray;
  

  if (!selectedArNos || selectedArNos.length === 0) {
    form.clear();
    return;
  }


  for (let i = this.userArray.length - 1; i >= 0; i--) {
    const formGroup = this.userArray.at(i) as FormGroup;
    const arNoValue = formGroup.get('arNo')?.value;
    

    const isSelected = selectedArNos.includes(arNoValue);

    if (!isSelected) {
      this.userArray.removeAt(i);
    }
  }
}

  onOpenSelect(evt: any) {
    if (evt == true && this.userList.length > 0) {
      this.userList = [];
    }
  }

  ngOnInit() {
    this.initAddForm();
    this.getDropdownLists()
  }

  getDropdownLists() {
    this.apiService.getAssociateCustomerListValues().subscribe(res => {
      this.customerDropDownLists = res;
    })
  }

  initAddForm() {
    this.addEditUserForm = this.fb.group({
      userArray: this.fb.array([])
    });
    if (this.editData) {
      this.editData.forEach((node: any) => {
        this.associateUserArray.push(this.editItemToUserArray(node));
      });
    }
  }

  editItemToUserArray(data: any) {
    this.userArrayForm = this.fb.group({
      arNo: [{ value: data.arno, disabled: true }],
      custName: [data.customerName, Validators.required],
      loginPageID: [data.loginPageId],
      styleSheet: [data.styleSheetId],
      brand: [data.brandId],
    });
    if (this.userArrayForm.get('styleSheet')?.value) {
      this.userArrayForm.get('brand')?.enable();
      this.userArrayForm.get('brand')?.setValidators([Validators.required]);
    }
    this.userArrayForm.get('styleSheet')?.valueChanges.subscribe(val => {
      if (val) {
        this.userArrayForm.get('brand')?.enable();
        this.userArrayForm.get('brand')?.setValidators([Validators.required]);
        this.userArrayForm.get('brand')?.updateValueAndValidity();
      }
      else {
        this.userArrayForm.get('brand')?.setValue('');
        this.userArrayForm.get('brand')?.disable();
        this.userArrayForm.get('brand')?.setErrors(null);
        this.userArrayForm.get('brand')?.updateValueAndValidity();
      }

    })

    return this.userArrayForm;
  }

  addItemToUserArray(data: any) {
    const formGroup = this.fb.group({
      arNo: [{ value: data.arNo, disabled: true }],
      custName: [data.customerName, Validators.required],
      copyCustName: [data.customerName],
      loginPageID: [''],
      styleSheet: [''],
      brand: [{ value: '', disabled: true }],
    });

    const styleSheetControl = formGroup.get('styleSheet');
    const brandControl = formGroup.get('brand');

    styleSheetControl?.valueChanges.subscribe(val => {
      if (val) {
        brandControl?.enable({ emitEvent: false });
        brandControl?.setValidators([Validators.required]);

      } else {
        brandControl?.setValue('', { emitEvent: false });
        brandControl?.clearValidators();
        brandControl?.disable({ emitEvent: false });
      }

      brandControl?.updateValueAndValidity();
    });

    return formGroup;


  }

  get userArray() {
    return this.addEditUserForm.controls["userArray"] as FormArray;
  }

  get associateUserArray() {
    return (this.addEditUserForm.controls["userArray"] as FormArray).controls as FormGroup[];
  }

  locationValChange(locationData: any, index: number) {


    this.associateUserFields[index + 1].value = [];
    this.apiService.getJobCode(this.selectedUsers, locationData.value).subscribe(res => {
      this.associateUserFields[index + 1].jobCodeList = res.data.map((node: any) => Object.assign(node, { disabled: false }));
      if (this.selectedPairs.length != 0) {
        const existLocation = this.selectedPairs.find((node: any) => node.locationVal == locationData.value);
        if (existLocation) {
          const jobCodeSet = new Set(existLocation.mappedJobCodes);
          this.associateUserFields[index + 1].jobCodeList.forEach((node: any) => {
            if (jobCodeSet.has(node.jobCode)) {
              node.disabled = true;
            }
          })
        }
      }

    })
  }

  clearRow(index: any) {
    if (this.editData && this.editData.length > 0) {
      this.initAddForm()
    }
    else {
      this.associateUserArray.at(index)?.get('loginPageID')?.setValue('');
      this.associateUserArray.at(index)?.get('custName')?.setValue( this.associateUserArray.at(index)?.get('copyCustName')?.value);
      this.associateUserArray.at(index)?.get('styleSheet')?.setValue('');
      this.associateUserArray.at(index)?.get('brand')?.setValue('');
      this.associateUserArray.at(index)?.get('styleSheet')?.setValue('');
    }

  }

  addRow() {
    if (this.selectedUsers.length > 0) {
      this.selectedUsers.forEach((node: any) => {
        if (this.associateUserArray.length == 0) {
          this.associateUserArray.push(this.addItemToUserArray(node));
        }
        else {
          this.selectedUsers.forEach((node: any) => {
            const alreadyExists = this.associateUserArray.some(
              (control: AbstractControl) => control.get('arNo')?.value === node.arNo
            );
            if (!alreadyExists) {
              this.associateUserArray.push(this.addItemToUserArray(node));
            }
          });
        }
      });
      this.invalidUserList = false;
    }
    else {
      this.invalidForm = true;
    }
  }



  saveRow() {
    if (this.associateUserArray.length == 0) {
      this.invalidUserList = true;
      return
    }
    const validList = this.associateUserArray.every(group => {
      const customerName = group.get('custName')?.value;
      const brand = group.get('brand')?.value;
      const styleSheet = group.get('styleSheet')?.value;
      const hasCustomer = !!customerName;
      const brandValid = styleSheet ? !!brand : true;

      return hasCustomer && brandValid;
    });

    if (!validList) {
      this.invalidUserForm = true;
      return
    }
    if (validList) {
      let arr: any = [];
      this.associateUserArray.map((res: FormGroup) => {
        let currentRowData: any = {
          "arno": res.get('arNo')?.value,
          "customerName": res.get('custName')?.value,
          "loginPageId": res.get('loginPageID')?.value,
          "styleSheet": res.get('styleSheet')?.value ? res.get('styleSheet')?.value : null,
          "brand": res.get('brand')?.value ? res.get('brand')?.value : null,
          "updateType": this.editData && this.editData.length > 0 ? "UPDATE" : "ADD"
        };
        arr.push(currentRowData)
      });
      this.emitData.emit(arr);
    }

  }

  closeForm() {
    this.closeDrawer.emit()
  }

  closeSelect(selectComponent: NzSelectComponent) {
    selectComponent.nzOpen = false;
    this.userList = [];
  }


}
